import React from 'react';
import Header from "./Header";
import Instructions from "./Instructions"
import UrlForm from "./UrlForm";
import Table from "./Table";
import {findChildren} from "./functions";

class App extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            search: '',
            events: [],
            data: [],
            expandAll: false
        }
    }

    componentDidMount() {
        let search = window.location.search;
        let params = new URLSearchParams(search);
        let url = params.get('url');

        if (url != null) {
            fetch(url, {
                method: 'POST'
            })
                .then(r => r.json())
                .then(r => this.setState({
                        events: r.timeline.events,
                        content: findChildren(r.timeline.events, 0)
                    })
                );
        }

    }

    filter(value) {
        this.setState({
            search: value,
            content: findChildren(this.state.events.filter(e => this.eventContainsText(e, value)), 0)
        })
    }

    eventContainsText(event, text) {
        return event.startupStep.name.indexOf(text) !== -1;
    }

    render() {
        return (
            <div className="flex flex-col w-full h-full bg-gray-200 px-10 py-2">
                <Header/>
                <div className="my-4 flex flex-row items-stretch">
                    <div className="my-6 flex-1">
                        <UrlForm/>
                    </div>
                    <div className="my-4">
                        {/*<input*/}
                        {/*    className="w-2/3 float-right flex-1 shadow appearance-none border rounded w-1/3 py-2 text-gray-700 leading-tight focus:outline-none focus:shadow-outline"*/}
                        {/*    id="username" type="text" value={this.state.search}*/}
                        {/*    onChange={e => this.filter(e.target.value)}*/}
                        {/*/>*/}
                        <label className="inline-flex items-center mt-3">
                            <input type="checkbox"
                                   className="form-checkbox h-5 w-5 text-gray-600"
                                   value={this.state.expandAll}
                                   onChange={() => this.setState({expandAll: !this.state.expandAll})}
                            />
                            <span className="ml-2 text-gray-700">Expand All</span>
                        </label>
                    </div>
                </div>
                <div>
                    {this.state.content ? <Table expandAll={this.state.expandAll} table={this.state.content}/> : <Instructions /> }
                </div>
            </div>
        );
    }
}

export default App;
